module.exports = __webpack_public_path__ + "img/nano4_global_s.478070a1.png";